module.exports = __webpack_public_path__ + "img/uptime.a35f335c.png";